import { Defaults } from 'es-decorators'
import { View } from 'es6/components/view'
import { getTemplate } from 'helpers/template-helper'
import { isMobile } from 'init/is-mobile'
import { CQC_COMMAND_TYPES, CQC_COMMAND_EVENT } from 'es6/constants'
import { currentCurrency } from 'init/current-currency'
import Backbone from 'init/backbone'

/**
 * Вид для поля изменения города
 */
@Defaults({
  el: '.choice-city',
  events: {
    click: 'togglePopup',
  },
  template: '#choice-city-item-template',
  additionalOptions: [
    'hasCurrency',
    'withRenderByChangeSettlement',
  ],
  withRenderByChangeSettlement: true,
})
export class ChoiceCityItemView extends View {
  /**
   * @inheritDoc
   */
  run () {
    this.template = getTemplate(this.template)
    if (typeof this.hasCurrency === 'undefined') {
      this.hasCurrency = !this.$el.hasClass('js-without-currency')
    }
    if (this.withRenderByChangeSettlement) {
      this.listenTo(this.settlement, 'change:name', this.changeCityText)
    }
    this.listenTo(Backbone, 'change-currency', this.changeCurrencyText)
  }

  /**
   * Переключение попапа
   * @param {Event} e
   */
  togglePopup (e) {
    e.preventDefault()
    Backbone.trigger(CQC_COMMAND_EVENT, { type: CQC_COMMAND_TYPES.showForm })
  }

  /**
   * Изменяет текст города.
   * @param {SettlementForm} settlement Модель города.
   */
  changeCityText (settlement) {
    // Псевдолинк со стрелкой
    const $cityLinkPseudo = this.$('.link_pseudo')
    const text = settlement.get('name')

    if ($cityLinkPseudo.length) {
      $cityLinkPseudo.text(text)
    } else {
      if (isMobile) {
        this.render({ text, currentCurrency })
      } else {
        this.$('.js-city-text').text(text)
      }
    }
  }

  /**
   * Изменение валюты в ссылке
   */
  changeCurrencyText () {
    if (this.$('.js-currency-text').length) {
      this.$('.js-currency-text').text(currentCurrency.name)
    } else if (isMobile) {
      this.render({
        text: this.settlement.get('name'),
        currentCurrency,
      })
    }
  }
}
